import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 37
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 md:gap-4 my-6" data-id="element-3">
      <TimeUnit value={format(timeLeft.hours)} label="HORAS" data-id="element-4" />
      <span className="text-orange text-3xl md:text-5xl font-bold pb-6" data-id="element-5">:</span>
      <TimeUnit value={format(timeLeft.minutes)} label="MINUTOS" data-id="element-6" />
      <span className="text-orange text-3xl md:text-5xl font-bold pb-6" data-id="element-7">:</span>
      <TimeUnit value={format(timeLeft.seconds)} label="SEGUNDOS" data-id="element-8" />
    </div>;
}
function TimeUnit({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-9">
      <div className="bg-navy-dark text-white text-4xl md:text-6xl font-bold rounded-lg p-3 md:p-5 min-w-[70px] md:min-w-[110px] text-center shadow-[inset_0_2px_10px_rgba(0,0,0,0.5)] border border-gray-800" data-id="element-10">
        {value}
      </div>
      <span className="text-gray-400 text-[10px] md:text-xs mt-3 font-bold tracking-[0.2em]" data-id="element-11">
        {label}
      </span>
    </div>;
}